var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22.286px",
    height: "20.571px",
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1431 1.25391H13.7146M23.1431 6.39676H13.7146M23.1431 11.5396H13.7146M23.1431 21.8253H13.7146M23.1431 16.6825H13.7146M0.857422 2.11105V8.96819C0.857422 9.44157 1.24118 9.82533 1.71456 9.82533H8.57171C9.04509 9.82533 9.42885 9.44157 9.42885 8.96819V2.11105C9.42885 1.63767 9.04509 1.25391 8.57171 1.25391H1.71456C1.24118 1.25391 0.857422 1.63767 0.857422 2.11105ZM0.857422 14.111V20.9682C0.857422 21.4415 1.24118 21.8253 1.71456 21.8253H8.57171C9.04509 21.8253 9.42885 21.4415 9.42885 20.9682V14.111C9.42885 13.6377 9.04509 13.2539 8.57171 13.2539H1.71456C1.24118 13.2539 0.857422 13.6377 0.857422 14.111Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSummaryIcon);
export default __webpack_public_path__ + "static/media/accountSummaryIcon.8d7ae9728d9b7624ec87dd8fdcc7f976.svg";
export { ForwardRef as ReactComponent };